// src/utils/toastUtils.js
import { toast } from "react-hot-toast";

// Configuración de iconos premium (circulares como el modal)
const iconSuccess = (
  <div className="w-6 h-6 flex items-center justify-center bg-green-500 rounded-full shadow-sm">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="white" strokeWidth={4} viewBox="0 0 24 24" width={14} height={14}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
  </div>
);

const iconError = (
  <div className="w-6 h-6 flex items-center justify-center bg-red-500 rounded-full shadow-sm">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="white" strokeWidth={4} viewBox="0 0 24 24" width={14} height={14}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  </div>
);

const iconInfo = (
  <div className="w-6 h-6 flex items-center justify-center bg-blue-500 rounded-full shadow-sm">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="white" strokeWidth={4} viewBox="0 0 24 24" width={14} height={14}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  </div>
);

const iconLoading = (
  <div className="w-6 h-6 flex items-center justify-center bg-yellow-400 rounded-full shadow-sm">
    <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
  </div>
);

const premiumStyle = {
  background: '#ffffff',
  color: '#1a1a1a',
  borderRadius: '16px',
  padding: '12px 16px',
  fontWeight: '600',
  fontSize: '14px',
  boxShadow: '0 12px 30px rgba(0, 0, 0, 0.12)',
  border: '1px solid rgba(0,0,0,0.05)',
};

export const showSuccess = (message) => {
  toast.success(message, {
    icon: iconSuccess,
    style: {
      ...premiumStyle,
      borderLeft: '5px solid #22c55e',
    },
  });
};

export const showError = (message) => {
  toast.error(message, {
    icon: iconError,
    style: {
      ...premiumStyle,
      borderLeft: '5px solid #ef4444',
    },
  });
};

export const showInfo = (message) => {
  toast(message, {
    icon: iconInfo,
    style: {
      ...premiumStyle,
      borderLeft: '5px solid #3b82f6',
    },
  });
};

/**
 * Muestra una notificación que maneja una promesa (Ideal para envíos de pedidos, cargas de fotos, etc.)
 * @param {Promise} promise - La promesa a ejecutar
 * @param {string} loadingMsg - Mensaje mientras carga
 * @param {string} successMsg - Mensaje al terminar con éxito
 * @param {string} errorMsg - Mensaje si algo falla
 */
export const showPromise = (promise, loadingMsg, successMsg, errorMsg) => {
  return toast.promise(
    promise,
    {
      loading: loadingMsg,
      success: successMsg,
      error: errorMsg,
    },
    {
      style: premiumStyle,
      loading: {
        icon: iconLoading,
        style: { ...premiumStyle, borderLeft: '5px solid #facc15' },
      },
      success: {
        icon: iconSuccess,
        style: { ...premiumStyle, borderLeft: '5px solid #22c55e' },
      },
      error: {
        icon: iconError,
        style: { ...premiumStyle, borderLeft: '5px solid #ef4444' },
      },
    }
  );
};
